/**
 * $filter = ex: { sku: { eq: "SKU"}}
 * $search = "SKU"
 */
import Config from 'config'

const environmentFieldGeneral = `
  master_sku
  model_sku
  sibling_products {
    url_key
    url_suffix
    color
    color_label
    color_image
  }
`

/* const environmentFieldConfigurable = `
  translations(attribute_code: "size"){
    label
    zone
  }
` */

function getProduct () {
  const attrArr = JSON.stringify(Config.Theme.attributesToload)
  return `query Products($filter: ProductAttributeFilterInput) {
      products(filter: $filter) {
      total_count
      items {
        id
        name
        sku
        url_key
        url_suffix
        meta_title
        meta_description
        meta_keyword
        meta_robots
        head_content_page
        seo_markup_product
        tax_rate
        attributesLabel (attributes_identifier: ${attrArr}) {
          label
          value
          attribute_id
          attribute_code
        }
        canonical_url
        custom_canonical_link
        color
        color_label
        color_image
        quantity
        ${environmentFieldGeneral}
        categories{
          id
          breadcrumbs{
            category_name
            category_url_path
          }          
        }
        small_image{
          url
          label
        }
        media_gallery {
          label
          url
          position
          disabled
          ... on ProductVideo {
            position
            video_content {
              media_type
              video_provider
              video_url
              video_title
              video_description
              video_metadata
            }
          }
        }
        price_tiers {
          discount {
            amount_off
            percent_off
          }
          final_price {
            value,
              currency
          }
          quantity
        }
        special_price
        price_range {
          minimum_price {
            discount {
              amount_off
              percent_off
            }
            final_price {
              value
              currency
            }
            regular_price {
              value
              currency
            }
            fixed_product_taxes {
              amount {
                value
              }
              label
            }
          },
          maximum_price {
            discount {
              amount_off
              percent_off
            }
            final_price {
              value
              currency
            }
            regular_price {
              value
              currency
            }
          }
        },
        product_links {
          position
          link_type
        }
        related_products {
          attribute_set_id
          url_key
          url_suffix
          sku
          name
          enabled
          media_gallery{
            url
            position
          }
        }
        upsell_products {
          attribute_set_id
          url_key
          url_suffix
          sku,
          name
          enabled
          media_gallery{
            url
            position
          }
        }
        ... on ConfigurableProduct {
          color
          options {
            title
            required
            sort_order
          }
          configurable_options {
            id,
            label
            attribute_code
            attribute_id
            position
            product_id
            values {
              value_index
              label
              default_label
              store_label
              use_default_value
            }
          }
          variants {
            product {
              id
              name
              sku
              stock_status
              quantity
              attribute_set_id
              special_from_date
              special_price
              special_to_date
              price_tiers {
                discount {
                  amount_off
                  percent_off
                }
                final_price {
                  value,
                    currency
                }
                quantity
              }
              price_range {
                minimum_price {
                  discount {
                    amount_off
                    percent_off
                  }
                  final_price {
                    value
                    currency
                  }
                  regular_price {
                    value
                    currency
                  }
                },
                maximum_price {
                  discount {
                    amount_off
                    percent_off
                  }
                  final_price {
                    value
                    currency
                  }
                  regular_price {
                    value
                    currency
                  }
                },
              },
            }
            attributes {
              label
              code
              value_index
            }
          }
        }
      }
    }
  }`
}

const product = getProduct()
export default product
